module.exports = __webpack_public_path__ + "img/IconPre-&Post-NatalCare.96246d19.svg";